import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 选择文件 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!

  return (_openBlock(), _createBlock(_component_a_upload, {
    action: "#",
    accept: _ctx.accept,
    multiple: _ctx.multiple,
    customRequest: _ctx.selectFile,
    remove: _ctx.removeFile,
    showUploadList: _ctx.showUploadList,
    maxCount: _ctx.maxCount
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_button, { type: "primary" }, {
        default: _withCtx(() => [
          _createVNode(_component_svg_icon, { "icon-name": "UploadOutlined" }),
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["accept", "multiple", "customRequest", "remove", "showUploadList", "maxCount"]))
}